import React, { useState } from "react";

function Navbar() {
  const [isActive, setActive] = useState(false);

  return (
    <header className="bg-blackGreen text-white sticky top-0 z-10">
      <section
        className={
          isActive
            ? "max-w-4xl mx-auto p-4 flex justify-between items-center"
            : "max-w-4xl mx-auto p-4  justify-between items-center hidden"
        }
      >
        <a href="#home">
        <h1 href="#home" className="text-2xl font-light ease-in-out duration-300 hover:text-black hover:font-normal">
          <span className="font-medium text-2xl text-minionYellow">I</span>smael <span className="font-medium text-2xl text-minionYellow">H</span>ernandez
        </h1>
        </a>
        <div>
          <button
            id="hamburguer-button"
            className="md:hidden text-3xl cursor-pointer"
            onClick={() => setActive(!isActive)}
          >
            &#9776;
          </button>
          <nav className="hidden md:block space-x-8 text-xl" aria-label="main">
            <a href="#home" className="ease-in-out duration-300 hover:text-black">
              Home
            </a>
            <a href="#habilidades" className="ease-in-out duration-300 hover:text-black">
              Skillset
            </a>
            <a href="#Projects_link" className="ease-in-out duration-300 hover:text-black">
              Projects
            </a>
            <a href="#contact" className="ease-in-out duration-300 hover:text-black">
              Contact
            </a>
          </nav>
        </div>
      </section>
      <section
        id="mobile-menu"
        className={
          isActive
            ? "absoulte top-0 bg-blackGreen w-full text-5xl flex-col justify-content-center origin-top animate-open-menu hidden"
            : "absoulte top-0 bg-blackGreen w-full text-5xl flex-col justify-content-center origin-top animate-open-menu flex"
        }
        onClick={() => setActive(!isActive)}
      >
        <button className="text-8xl self-end px-6">&times;</button>
        <nav
          className="flex flex-col min-h-screen items-center py-8"
          aria-label="mobile"
        >
          <a href="#home" className="w-full text-center py-6 ease-in-out duration-300 hover:text-black">
            Home
          </a>
          <a
            href="#habilidades"
            className="w-full text-center py-6 ease-in-out duration-300 hover:text-black"
          >
            Skillset
          </a>
          <a
            href="#Projects_link"
            className="w-full text-center py-6 ease-in-out duration-300 hover:text-black"
          >
            Projects
          </a>
          <a
            href="#contact"
            className="w-full text-center py-6 ease-in-out duration-300 hover:text-black"
          >
            Contact
          </a>
        </nav>
      </section>
    </header>
  );
}

export default Navbar;
